<span *ngIf="!isCustomFilter" (click)="showFilterOptions(filterWindow);" title="Filter" [ngClass]="{'filter-ic': true, 'disabled': isBusy}">
  <ng-container *ngTemplateOutlet="filterSVG"></ng-container>
</span>

<!-- (click)="onContextMenu($event, customFilter)" -->
<div #customFilter *ngIf="isCustomFilter" class="custom-filter-advanced filter-ic" (click)="showFilterOptions(filterWindow);" [class.has-filter]="hasFilters && applied">
  <span>Filter</span>
  <mat-icon>filter_list</mat-icon>
</div>


<ng-template #filterWindow>
    <div class="modal-header">
      <h6 class="modal-title"><span>{{isCustomFilter ? 'Filters' : 'Edit View'}}</span></h6>
      <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close" (click)="hide()">
        <span aria-hidden="true" style="font-size: 25px;">&times;</span>
      </button>
    </div>
    <div class="modal-body custom-scrollbar">
      <div>
        <div *ngIf="!isCustomFilter" class="container" style="padding-left: 0;">
          <div class="row">
            <div class="col-sm-2">
              <p class="filter-label">View Name</p>
            </div>
            <div class="col-sm-10">
              <input #viewName type="text" 
              [ngClass]="{'form-control': true, 'invalid': isEmptyView}"
              (keyup)="onKeyUp(viewName.value)"/>
              <span></span>
              <div *ngIf="isEmptyView" class="invalid-feedback" style="display: block">
                <div>View name is required</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="margin-top: 20px;padding-left: 0;">
          <div class="row">
            <div class="col-sm-2">
              <p class="filter-label">Filters</p>
            </div>
            <div class="col-sm-10">
              <div *ngFor="let option of filterOptions;index as i" class="filter-container">
                <div #dateInput *ngIf="isRPF1 && (option.FilterField === 'CreatedSubmittedDateFrom')" class="input-group date-group">
                  <input
                    [matDatepicker]="fromPicker"
                    type="text"
                    [(ngModel)]="fromDate"
                    [max]="toDate"
                    placeholder="From Date"
                    (dateChange)="onDateChange($event.value, 'FromDate')"
                    (ngModelChange)="onDateChange($event, 'FromDate')"
                    autocomplete="off">
                  <mat-datepicker #fromPicker></mat-datepicker>
                  <div class="input-group-append date-group" (click)="fromPicker.open()" tabindex="0" (keyup.enter)="fromPicker.open()">
                    <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                 <div #dateInput *ngIf="isRPF1 && (option.FilterField === 'CreatedSubmittedDateTo')" class="input-group date-group">
                  <input
                    [matDatepicker]="toPicker"
                    type="text"
                    [(ngModel)]="toDate"
                    [min]="fromDate"
                    placeholder="To Date"
                    (dateChange)="onDateChange($event.value, 'ToDate')"
                    (ngModelChange)="onDateChange($event, 'ToDate')"
                    autocomplete="off">
                  <mat-datepicker #toPicker></mat-datepicker>
                  <div class="input-group-append date-group" (click)="toPicker.open()" tabindex="0" (keyup.enter)="toPicker.open()">
                    <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <ng-select #filter class="dropdown-ng-select filter-option" [ngClass]="{'loading': option.IsLoading}" *ngIf="option.FilterField !== 'CreatedSubmittedDateFrom' && option.FilterField !== 'CreatedSubmittedDateTo'"
                  [items]="option.FilterOptionItems"
                  (click)="getFilterOptions(option.FilterField, $event);"
                  [isOpen]="option.IsDropdownOpen"
                  (close)="onCloseFilterOptions()"
                  (change)="checkItem(option.FilterField, $event, filter)"
                  (blur)="onBlur(option.FilterField , $event)"
                  [multiple]="true"
                  [searchable]="false"
                  [closeOnSelect]="false"
                  [clearOnBackspace]="false"
                  [placeholder]="option.FilterOptionDisplay"
                  [(ngModel)]="option.SelectedFilterItem"
                  bindValue="ItemValue"
                  bindLabel="ItemDisplay"
                  appendTo="body">
                  <ng-template ng-header-tmp>
                    <div #headerFilter class="header-filter" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)">
                      <!-- <p [ngClass]="{'header-title': true, 'has-filter': option.HasAdvancedFilter}" (click)="openCustomFilter(option)">Custom Filter
                        <span *ngIf="option.HasAdvancedFilter" class="clear-filter" (click)="clearFilter($event, option)" title="Clear filter"></span>
                      </p> 
                      <div class="divider"></div> -->
                      <input class="custom-input-search" type="text" (input)="input(filter, $event)" placeholder="Type to search.." tabindex="0" (blur)="onBlurInput($event)"/>
                      <div class="sub-header">
                        <label class="checkbox-container"> Select All
                          <input type="checkbox" (change)="selectAll($event, filter)" class="checkbox-input" tabindex="0" (blur)="onBlurInput($event)">
                          <span class="checkmark-custom"></span>
                        </label>
                        <!-- <span *ngIf="isLoading"  class="loading-dropdown" title="loading dropdown list..">Loading dropdown list..</span> -->
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        <span class="ng-value-label">{{item.ItemDisplay}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 10">
                        <span class="ng-value-label">{{items.length - 10}} more...</span>
                    </div>
                  </ng-template>
                </ng-select>
                <div class="custom-filter" *ngIf="isRPF1 && option.FilterField !== 'CreatedSubmittedDateFrom' && option.FilterField !== 'CreatedSubmittedDateTo'">
                  <!-- <img *ngIf="option.HasAdvancedFilter" class="filter-ic" src="../../assets/images/filter-blue-fill.png" (click)="openCustomFilter(option)" matTooltip="Custom filter"/> -->
                  <span *ngIf="option.HasAdvancedFilter" (click)="openCustomFilter(option)" title="Custom filter added" style="cursor:pointer;">
                    <ng-container *ngTemplateOutlet="filterFilledSVG"></ng-container>
                  </span>
                  <!-- <img *ngIf="!option.HasAdvancedFilter" class="filter-ic" src="../../assets/images/filter-blue.png" (click)="openCustomFilter(option)" matTooltip="Custom filter"/> -->
                  <span *ngIf="!option.HasAdvancedFilter" (click)="openCustomFilter(option)" title="Custom filter" style="cursor:pointer;">
                    <ng-container *ngTemplateOutlet="filterSVG"></ng-container>
                  </span>
                </div>
              </div>
              <div *ngIf="filterOptions.length == 0">
                <p class="filter-label" style="padding-left: 0;">Filters have not been defined for this view.  Please contact system administrator.</p>
              </div>
              <div class="clearfix"></div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button [disabled]="!hasFilters" type="button" class="btn btn-primary btn-clear" (click)="clearAllFilters()">Clear All Filters</button>
      <button *ngIf="!isCustomFilter" type="button" class="btn btn-primary save-view-button" [class.loading]="isApplyingFilter" (click)="createNewView()">{{ isApplyingFilter ? '' : 'Save As New View' }}</button>
      <button type="button" class="btn btn-primary apply-button" [class.loading]="isApplyingFilter" *ngIf="!isRPF1" (click)="applyFilterChanges()">{{ isApplyingFilter ? '' : 'Apply' }}</button>
      <button type="button" class="btn btn-primary apply-button" [class.loading]="isApplyingFilter" *ngIf="isRPF1" (click)="applyFilterChanges1()">{{ isApplyingFilter ? '' : 'Apply' }}</button>
    </div>
  </ng-template>

  <ng-template #filterSVG>
    <svg class="filter-svg" viewBox="-4 0 393 393.99003" xmlns="http://www.w3.org/2000/svg">
      <path d="m368.3125 0h-351.261719c-6.195312-.0117188-11.875 3.449219-14.707031 8.960938-2.871094 5.585937-2.3671875 12.3125 1.300781 17.414062l128.6875 181.28125c.042969.0625.089844.121094.132813.183594 4.675781 6.3125 7.203125 13.957031 7.21875 21.816406v147.796875c-.027344 4.378906 1.691406 8.582031 4.777344 11.6875 3.085937 3.105469 7.28125 4.847656 11.65625 4.847656 2.226562 0 4.425781-.445312 6.480468-1.296875l72.3125-27.574218c6.480469-1.976563 10.78125-8.089844 10.78125-15.453126v-120.007812c.011719-7.855469 2.542969-15.503906 7.214844-21.816406.042969-.0625.089844-.121094.132812-.183594l128.683594-181.289062c3.667969-5.097657 4.171875-11.820313 1.300782-17.40625-2.832032-5.511719-8.511719-8.9726568-14.710938-8.960938zm-131.53125 195.992188c-7.1875 9.753906-11.074219 21.546874-11.097656 33.664062v117.578125l-66 25.164063v-142.742188c-.023438-12.117188-3.910156-23.910156-11.101563-33.664062l-124.933593-175.992188h338.070312zm0 0"/>
    </svg>
  </ng-template>

  <ng-template #filterFilledSVG>
      <svg class="filter-svg filled" viewBox="-5 0 374 374.01033" xmlns="http://www.w3.org/2000/svg"><path d="m357.84375 0c2.5.015625 4.777344 1.4375 5.886719 3.675781 1.113281 2.242188.863281 4.914063-.636719 6.914063l-128.679688 181.28125c-5.949218 8.046875-9.171874 17.78125-9.203124 27.789062v120.011719c0 2.648437-1.308594 5.289063-3.929688 5.949219l-72.878906 27.789062c-2.015625.933594-4.371094.769532-6.238282-.4375-1.863281-1.210937-2.980468-3.289062-2.953124-5.511718v-147.800782c-.027344-10.007812-3.25-19.742187-9.199219-27.789062l-128.679688-181.28125c-1.5-2-1.75-4.671875-.636719-6.914063 1.109376-2.238281 3.386719-3.660156 5.886719-3.675781zm0 0"/>
      </svg>
  </ng-template>

<context-menu [useBootstrap4]="true">
  <ng-template contextMenuItem passive="true">
    <!-- <h6 class="modal-title"><span>Filters</span></h6> -->
    <div class="modal-body custom-scrollbar">
      <div>
        <div class="container" style="margin-top: 20px;padding-left: 0;">
          <div class="row">
            <div class="col-sm-2">
              <p class="filter-label">Filters</p>
            </div>
            <div class="col-sm-10">
              <div *ngFor="let option of filterOptions;index as i" class="filter-container">
                <ng-select #filter class="dropdown-ng-select filter-option" [ngClass]="{'loading': option.IsLoading}"
                  [items]="option.FilterOptionItems"
                  (click)="getFilterOptions(option.FilterField, $event); filter.focus()"
                  [isOpen]="option.IsDropdownOpen"
                  (close)="onCloseFilterOptions()"
                  (change)="checkItem(option.FilterField, $event, filter)"
                  (blur)="onBlur(option.FilterField , $event)"
                  [multiple]="true"
                  [searchable]="false"
                  [closeOnSelect]="false"
                  [clearOnBackspace]="false"
                  [placeholder]="option.FilterOptionDisplay"
                  [(ngModel)]="option.SelectedFilterItem"
                  bindValue="ItemValue"
                  bindLabel="ItemDisplay"
                  appendTo="body">
                  <ng-template ng-header-tmp>
                    <div #headerFilter class="header-filter" (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)">
                      <!-- <p [ngClass]="{'header-title': true, 'has-filter': option.HasAdvancedFilter}" (click)="openCustomFilter(option)">Custom Filter
                        <span *ngIf="option.HasAdvancedFilter" class="clear-filter" (click)="clearFilter($event, option)" title="Clear filter"></span>
                      </p> 
                      <div class="divider"></div> -->
                      <input class="custom-input-search" type="text" (input)="input(filter, $event)" placeholder="Type to search.." tabindex="0" (blur)="onBlurInput($event)"/>
                      <div class="sub-header">
                        <label class="checkbox-container"> Select All
                          <input type="checkbox" (change)="selectAll($event, filter)" class="checkbox-input" tabindex="0" (blur)="onBlurInput($event)">
                          <span class="checkmark-custom"></span>
                        </label>
                        <!-- <span *ngIf="isLoading"  class="loading-dropdown" title="loading dropdown list..">Loading dropdown list..</span> -->
                      </div>
                    </div>
                  </ng-template>
                  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                    <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                        <span class="ng-value-label">{{item.ItemDisplay}}</span>
                    </div>
                    <div class="ng-value" *ngIf="items.length > 10">
                        <span class="ng-value-label">{{items.length - 10}} more...</span>
                    </div>
                  </ng-template>
                </ng-select>
                <div class="custom-filter">
                  <!-- <img *ngIf="option.HasAdvancedFilter" class="filter-ic" src="../../assets/images/filter-blue-fill.png" (click)="openCustomFilter(option)" matTooltip="Custom filter"/> -->
                  <span *ngIf="option.HasAdvancedFilter" (click)="openCustomFilter(option)" matTooltip="Custom filter" style="cursor:pointer;">
                    <ng-container *ngTemplateOutlet="filterFilledSVG"></ng-container>
                  </span>
                  <!-- <img *ngIf="!option.HasAdvancedFilter" class="filter-ic" src="../../assets/images/filter-blue.png" (click)="openCustomFilter(option)" matTooltip="Custom filter"/> -->
                  <span *ngIf="!option.HasAdvancedFilter" (click)="openCustomFilter(option)" matTooltip="Custom filter" style="cursor:pointer;">
                    <ng-container *ngTemplateOutlet="filterSVG"></ng-container>
                  </span>
                </div>
              </div>
              <div *ngIf="filterOptions.length == 0">
                <p class="filter-label" style="padding-left: 0;">Filters have not been defined for this view.  Please contact system administrator.</p>
              </div>
              <div class="clearfix"></div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right;padding-bottom: 10px;display: flex;flex-flow: row-reverse;">
      <button type="button" class="btn btn-primary apply-button" [class.loading]="isApplyingFilter" (click)="applyFilterChanges()">{{ isApplyingFilter ? '' : 'Apply' }}</button>
      <button [disabled]="!hasFilters" type="button" class="btn btn-primary btn-clear mr-2" (click)="clearAllFilters()">Clear All Filters</button>
    </div>
  </ng-template>
</context-menu>